import { useQuery } from '@tanstack/react-query'
import { AdminInvoiceService } from '../services'
import { OrderAdminDto, TInvoiceListOptions, APIInvoiceAdminDtoResponse, CustomInvoiceAdminDto } from '../types'
import { defaultQueryOptions } from './common'

export const useAdminCancelInvoice = (
  locationName: string,
  orderId: string,
  invoiceId: string,
  amount?: number | null
) => {
  return useQuery<OrderAdminDto>({
    queryKey: ['adminCancelInvoice', locationName, orderId, invoiceId, amount],
    queryFn: () => AdminInvoiceService.cancelInvoice(locationName, orderId, invoiceId, amount),
    ...defaultQueryOptions,
    enabled: false,
  })
}

export const useAdminInvoice = (locationName: string, invoiceId: string) => {
  return useQuery<CustomInvoiceAdminDto>({
    queryKey: ['adminInvoice', locationName, invoiceId],
    queryFn: () => AdminInvoiceService.get(locationName, invoiceId),
    enabled: Boolean(invoiceId),
    ...defaultQueryOptions,
  })
}

export const useAdminInvoiceList = (locationName: string, options: TInvoiceListOptions) => {
  return useQuery<APIInvoiceAdminDtoResponse>({
    queryKey: ['adminInvoiceList', locationName, options],
    queryFn: () => AdminInvoiceService.getList(locationName, options),
    enabled: true,
    ...defaultQueryOptions,
  })
}
